import { render, staticRenderFns } from "./WebRouter.vue?vue&type=template&id=520d7c9d&scoped=true&"
import script from "./WebRouter.vue?vue&type=script&lang=js&"
export * from "./WebRouter.vue?vue&type=script&lang=js&"
import style0 from "./WebRouter.vue?vue&type=style&index=0&id=520d7c9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520d7c9d",
  null
  
)

export default component.exports